import React,{useState,useEffect, useRef, useLayoutEffect} from 'react';
import { useTheme } from '@mui/material/styles';
//import short_filmsmedium
import '../static/css/shortfilms-medium-webfont.ttf'
const sibling_ordered = [ '00', '1', '2', '3', '4', '5', '6', '7', '8', '9','10', '11','12','13','14','15','16','17', '18', '19', '20', '21','22','23','24','25','26','27','28', '29', '30', '31','32','33','34','35','36','37','38','39', '40', '41','42','43','44','45','46','47','48', '49', '50', '51','52','53','54','55','56','57','58','59', '60', '61']
let sibling = {}

sibling = {
    '00': ['2', '4'], 
    '1': ['2', '28'],
    '2': ['00', '1', '3', '4', '5'],
    '3': ['2', '5', '6', '34', '28'],
    '4': ['00', '2', '10', '11'],
    '5': ['2', '3', '8', '10', '18'],
    '6': ['3', '7', '8', '9', '34'],
    '7': ['6', '8', '9', '16', '21', '23'],
    '8': ['5', '6', '7', '18', '23'],
    '9': ['16', '6', '7'], 
    '10':['4', '5', '18', '13', '14'],
    '11':['13', '4', '15'],
    '12':[ '45', '13', '14', '15', '25', '29'],
    '13':['10', '11', '12', '14', '15'],
    '14': ['10', '12', '13', '18', '19', '25'],
    '15': ['11', '12', '13', '29', '30'],
    '16': ['32', '7', '9', '17', '21'],
    '17': ['32', '16', '20', '22'],
    '18': ['5', '8', '10', '14', '19', '23'],
    '19': ['36', '38', '52', '14', '18', '23', '25'],
    '20': ['17', '61', '22'],
    '21': ['32', '7', '16', '52', '23', '26', '31'],
    '22': ['32', '33', '17', '20', '26', '61'],
    '23': ['7', '8', '18', '19', '52', '21'],
    '24': ['33', '26', '27', '50'],
    '25': ['36', '12', '45', '14', '48', '19'],
    '26': ['32', '33', '21', '22', '24', '27', '31'],
    '27': ['40', '54', '56', '24', '26', '31'],
    '28': ['1', '34', '3'],
    '29': ['43', '12', '45', '15', '30'],
    '30': ['43', '46', '15', '29'],
    '31': ['52', '21', '38', '56', '26', '27'],
    '32': ['16', '17', '21', '22', '26'],
    '33': ['50', '22', '24', '26', '61'],
    '34': ['3', '28', '6'],
    '35': ['40', '54', '55'],
    '36': ['37', '38', '48', '19', '53', '25'],
    '37': ['36', '39', '41', '42', '48', '53', '57'],
    '38': ['19', '31', '36', '53', '56'],
    '39': ['37', '41', '57', '59'],
    '40': ['35', '27', '50', '54'],
    '41': ['37', '39', '42', '44'],
    '42': ['37', '41', '44', '45', '48'],
    '43': ['44', '45', '46', '51', '29', '30'],
    '44': ['41', '42', '43', '45', '51'],
    '45': ['42', '43', '12', '44', '48', '25', '29'],
    '46': ['43', '51', '30'],
    '47': ['49', '54', '58', '55'],
    '48': ['36', '37', '42', '45', '25'],
    '49': ['47', '59', '60', '55'],
    '50': ['24', '33', '40'],
    '51': ['43', '44', '46'],
    '52': ['19', '23', '21', '31'], 
    '53': ['36', '37', '38', '57', '58'],
    '54': ['35', '40', '47', '56', '58', '27'],
    '55': ['35', '49', '60', '47'],
    '56': ['54', '58', '27', '31', '38'],
    '57': ['37', '39', '53', '58', '59'],
    '58': ['47', '53', '54', '56', '57', '59'],
    '59': ['57', '39', '49', '58'],
    '60': ['49', '55'],
    '61': ['33', '20', '22']
}

let path =[29, 30, 43, 45, 44, 51, 46, 23, 19, 38, 53, 57, 39, 59, 49, 60, 25, 36, 48, 37, 41, 42, 24, 50, 33, 61, 20, 22, 26, 32, 17, 16, 9, 21, 52, 31, 27, 40, 35, 54, 56, 58, 47, 55, 4, 11, 15, 12, 13, 10, 14, 18, 5, 8, 6, 7, 0, 2, 1, 3, 28, 34]

let polygons = [
    [[1.0, 0.15704147178822556], [0.9058931816457017, 0.2358199473091625], [1.0, 0.35450361619504994], [1.0, 0.15704147178822556]],
    [[0.8876094601899287, 0.08205456704701353], [1.0, 0.15704147178822556], [1.0, 0.0], [0.9396273851849212, 0.0], [0.8876094601899287, 0.08205456704701353]],
    [[0.8149824907767095, 0.17757880020539424], [0.8516881004734557, 0.25925806368658344], [0.9058931816457017, 0.2358199473091625], [1.0, 0.15704147178822556], [0.8876094601899287, 0.08205456704701353], [0.8149824907767095, 0.17757880020539424]],
    [[0.8149824907767095, 0.17757880020539424], [0.8876094601899287, 0.08205456704701353], [0.8029704092294766, 0.054977159275619318], [0.7184818838628265, 0.09318774726491982], [0.7122081710481467, 0.1338663173646183], [0.8149824907767095, 0.17757880020539424]],
    [[1.0, 0.3789717260780473], [1.0, 0.35450361619504994], [0.9058931816457017, 0.2358199473091625], [0.8516881004734557, 0.25925806368658344], [0.850969000097256, 0.406453901254347], [1.0, 0.3789717260780473]], 
    [[0.6894736208008635, 0.2774284397423263], [0.7204360760166576, 0.3075738723578572], [0.8516881004734557, 0.25925806368658344], [0.8149824907767095, 0.17757880020539424], [0.7122081710481467, 0.1338663173646183], [0.6894736208008635, 0.2774284397423263]],
    [[0.5451936869030801, 0.08814857329510487], [0.590622846561061, 0.14480657152719673], [0.7122081710481467, 0.1338663173646183], [0.7184818838628265, 0.09318774726491982], [0.6585451314718188, 0.0], [0.5696785587886377, 0.0], [0.5451936869030801, 0.08814857329510487]],
    [[0.4391195039383093, 0.11012537124094353], [0.4137190658073377, 0.154845437099476], [0.47930859946163074, 0.24001000510234716], [0.5636002273462666, 0.23538518508088502], [0.590622846561061, 0.14480657152719673], [0.5451936869030801, 0.08814857329510487], [0.4391195039383093, 0.11012537124094353]],
    [[0.7122081710481467, 0.1338663173646183], [0.590622846561061, 0.14480657152719673], [0.5636002273462666, 0.23538518508088502], [0.5953202543526732, 0.2780409353631573], [0.6894736208008635, 0.2774284397423263], [0.7122081710481467, 0.1338663173646183]],
    [[0.4391195039383093, 0.11012537124094353], [0.5451936869030801, 0.08814857329510487], [0.5696785587886377, 0.0], [0.3930663817577022, 0.0], [0.4391195039383093, 0.11012537124094353]],
    [[0.8516881004734557, 0.25925806368658344], [0.7204360760166576, 0.3075738723578572], [0.723776674841434, 0.3668259724141095], [0.7878846332082949, 0.41511300068903767], [0.850969000097256, 0.406453901254347], [0.8516881004734557, 0.25925806368658344]],
    [[0.850969000097256, 0.406453901254347], [0.9136569570849058, 0.5239768610680188], [1.0, 0.5394058358419677], [1.0, 0.3789717260780473], [0.850969000097256, 0.406453901254347]], [[0.8552489127230739, 0.6667895881127904], [0.8799260052701422, 0.5556622898651518], [0.7330278003592843, 0.5376671314989275], [0.6941049913470903, 0.5678795670071839], [0.7351770346465978, 0.6770554069722294], [0.7716913824750394, 0.6919078092773674], [0.8552489127230739, 0.6667895881127904]], [[0.7878846332082949, 0.41511300068903767], [0.7330278003592843, 0.5376671314989275], [0.8799260052701422, 0.5556622898651518], [0.9136569570849058, 0.5239768610680188], [0.850969000097256, 0.406453901254347], [0.7878846332082949, 0.41511300068903767]], [[0.6210729946331893, 0.43601199532066814], [0.6319784346401744, 0.5186286222842511], [0.6941049913470903, 0.5678795670071839], [0.7330278003592843, 0.5376671314989275], [0.7878846332082949, 0.41511300068903767], [0.723776674841434, 0.3668259724141095], [0.6210729946331893, 0.43601199532066814]], [[1.0, 0.731887551221275], [1.0, 0.5394058358419677], [0.9136569570849058, 0.5239768610680188], [0.8799260052701422, 0.5556622898651518], [0.8552489127230739, 0.6667895881127904], [0.9386806028007719, 0.729624716240153], [1.0, 0.731887551221275]], [[0.2878060958554001, 0.1188384441385233], [0.3554855615057558, 0.17258179586318423], [0.4137190658073377, 0.154845437099476], [0.4391195039383093, 0.11012537124094353], [0.3930663817577022, 0.0], [0.30618399843948607, 0.0], [0.2878060958554001, 0.1188384441385233]], [[0.16281148208427518, 0.09075966678515365], [0.19609447021047555, 0.13871954934155384], [0.2878060958554001, 0.1188384441385233], [0.30618399843948607, 0.0], [0.17502960414556268, 0.0], [0.16281148208427518, 0.09075966678515365]], [[0.6894736208008635, 0.2774284397423263], [0.5953202543526732, 0.2780409353631573], [0.5639150080410249, 0.38470662376911374], [0.6210729946331893, 0.43601199532066814], [0.723776674841434, 0.3668259724141095], [0.7204360760166576, 0.3075738723578572], [0.6894736208008635, 0.2774284397423263]], [[0.6319784346401744, 0.5186286222842511], [0.6210729946331893, 0.43601199532066814], [0.5639150080410249, 0.38470662376911374], [0.5204458372927893, 0.3891790302185355], [0.4240552422618216, 0.483872172450601], [0.4720949194403382, 0.556907448828166], [0.5542047406824002, 0.5774211640988801], [0.6319784346401744, 0.5186286222842511]], [[0.06906999197978334, 0.0821427000720589], [0.16281148208427518, 0.09075966678515365], [0.17502960414556268, 0.0], [0.0, 0.0], [0.0, 0.011359147689904807], [0.06906999197978334, 0.0821427000720589]], [[0.3537602454680855, 0.333938023716593], [0.4441166441878221, 0.3105874259219291], [0.47930859946163074, 0.24001000510234716], [0.4137190658073377, 0.154845437099476], [0.3554855615057558, 0.17258179586318423], [0.31051313737737696, 0.2757166793067158], [0.3264562175774023, 0.3237917159640897], [0.3537602454680855, 0.333938023716593]], [[0.17439703579091242, 0.22538198722730762], [0.19609447021047555, 0.13871954934155384], [0.16281148208427518, 0.09075966678515365], [0.06906999197978334, 0.0821427000720589], [0.043778088062150305, 0.17368727054661914], [0.14711349388438083, 0.24413257884605438], [0.17439703579091242, 0.22538198722730762]], [[0.5953202543526732, 0.2780409353631573], [0.5636002273462666, 0.23538518508088502], [0.47930859946163074, 0.24001000510234716], [0.4441166441878221, 0.3105874259219291], [0.5204458372927893, 0.3891790302185355], [0.5639150080410249, 0.38470662376911374], [0.5953202543526732, 0.2780409353631573]], [[0.19498519149179894, 0.40846675269067345], [0.14125191609762416, 0.27922598507392064], [0.03690306796464825, 0.32410393571869145], [0.10693271229777918, 0.4411925270273991], [0.19498519149179894, 0.40846675269067345]], [[0.5645661995465214, 0.6266202517455921], [0.6674064004310187, 0.7126763583712399], [0.7351770346465978, 0.6770554069722294], [0.6941049913470903, 0.5678795670071839], [0.6319784346401744, 0.5186286222842511], [0.5542047406824002, 0.5774211640988801], [0.5645661995465214, 0.6266202517455921]], [[0.19498519149179894, 0.40846675269067345], [0.2311715371895734, 0.4176156070767503], [0.3264562175774023, 0.3237917159640897], [0.31051313737737696, 0.2757166793067158], [0.17439703579091242, 0.22538198722730762], [0.14711349388438083, 0.24413257884605438], [0.14125191609762416, 0.27922598507392064], [0.19498519149179894, 0.40846675269067345]], [[0.14282316741592668, 0.551663174709632], [0.19240335688786142, 0.5744543468004812], [0.26684499083482294, 0.4952101164710062], [0.2311715371895734, 0.4176156070767503], [0.19498519149179894, 0.40846675269067345], [0.10693271229777918, 0.4411925270273991], [0.14282316741592668, 0.551663174709632]], [[0.8029704092294766, 0.054977159275619318], [0.8876094601899287, 0.08205456704701353], [0.9396273851849212, 0.0], [0.8022410180124921, 0.0], [0.8029704092294766, 0.054977159275619318]], [[0.8569136271656689, 0.8197383185228726], [0.9386806028007719, 0.729624716240153], [0.8552489127230739, 0.6667895881127904], [0.7716913824750394, 0.6919078092773674], [0.7962079715427153, 0.8112868153908568], [0.8569136271656689, 0.8197383185228726]], [[0.8996952395388631, 0.8970326952400252], [1.0, 0.8543064251337743], [1.0, 0.731887551221275], [0.9386806028007719, 0.729624716240153], [0.8569136271656689, 0.8197383185228726], [0.8996952395388631, 0.8970326952400252]], [[0.4240552422618216, 0.483872172450601], [0.3537602454680855, 0.333938023716593], [0.3264562175774023, 0.3237917159640897], [0.2311715371895734, 0.4176156070767503], [0.26684499083482294, 0.4952101164710062], [0.29992570383046435, 0.5106546411882987], [0.4240552422618216, 0.483872172450601]], [[0.3554855615057558, 0.17258179586318423], [0.2878060958554001, 0.1188384441385233], [0.19609447021047555, 0.13871954934155384], [0.17439703579091242, 0.22538198722730762], [0.31051313737737696, 0.2757166793067158], [0.3554855615057558, 0.17258179586318423]], [[0.14711349388438083, 0.24413257884605438], [0.043778088062150305, 0.17368727054661914], [0.0, 0.18779428799228035], [0.0, 0.3173167473636119], [0.03690306796464825, 0.32410393571869145], [0.14125191609762416, 0.27922598507392064], [0.14711349388438083, 0.24413257884605438]], [[0.7184818838628265, 0.09318774726491982], [0.8029704092294766, 0.054977159275619318], [0.8022410180124921, 0.0], [0.6585451314718188, 0.0], [0.7184818838628265, 0.09318774726491982]], [[0.09350590879701809, 0.716098494442338], [0.10851880979265245, 0.5841686042568631], [0.0, 0.5636975133739178], [0.0, 0.7146135721020539], [0.09350590879701809, 0.716098494442338]], [[0.5116287840371967, 0.7262985515337854], [0.5645661995465214, 0.6266202517455921], [0.5542047406824002, 0.5774211640988801], [0.4720949194403382, 0.556907448828166], [0.3882893914503447, 0.6638790627978747], [0.46532545533787595, 0.733718741024623], [0.5116287840371967, 0.7262985515337854]], [[0.5814975136113691, 0.7866301764869948], [0.5116287840371967, 0.7262985515337854], [0.46532545533787595, 0.733718741024623], [0.4353650022192679, 0.829074150197124], [0.4642558752553965, 0.8903926466797591], [0.4948820363754486, 0.8979165262504609], [0.5596729135033728, 0.8596044481544963], [0.5814975136113691, 0.7866301764869948]], [[0.3882893914503447, 0.6638790627978747], [0.4720949194403382, 0.556907448828166], [0.4240552422618216, 0.483872172450601], [0.29992570383046435, 0.5106546411882987], [0.32851498967179615, 0.6761902913899492], [0.3882893914503447, 0.6638790627978747]], [[0.4948820363754486, 0.8979165262504609], [0.4642558752553965, 0.8903926466797591], [0.3610554821287574, 0.9648793469876519], [0.355021880888968, 1.0], [0.5395189787852384, 1.0], [0.4948820363754486, 0.8979165262504609]], [[0.10851880979265245, 0.5841686042568631], [0.14282316741592668, 0.551663174709632], [0.10693271229777918, 0.4411925270273991], [0.0, 0.4750694118792824], [0.0, 0.5636975133739178], [0.10851880979265245, 0.5841686042568631]], [[0.6474639103526567, 0.9017080258765414], [0.5596729135033728, 0.8596044481544963], [0.4948820363754486, 0.8979165262504609], [0.5395189787852384, 1.0], [0.6651120407839647, 1.0], [0.6474639103526567, 0.9017080258765414]], [[0.6497462825613068, 0.7542346789173351], [0.5814975136113691, 0.7866301764869948], [0.5596729135033728, 0.8596044481544963], [0.6474639103526567, 0.9017080258765414], [0.7092029258536026, 0.8432703968019183], [0.6497462825613068, 0.7542346789173351]], [[0.7551484317488599, 0.8484153308573631], [0.7622830344072859, 0.9226647314090442], [0.8888710283282851, 0.9315108199671709], [0.8996952395388631, 0.8970326952400252], [0.8569136271656689, 0.8197383185228726], [0.7962079715427153, 0.8112868153908568], [0.7551484317488599, 0.8484153308573631]], [[0.7622830344072859, 0.9226647314090442], [0.7551484317488599, 0.8484153308573631], [0.7092029258536026, 0.8432703968019183], [0.6474639103526567, 0.9017080258765414], [0.6651120407839647, 1.0], [0.7457774232302694, 1.0], [0.7622830344072859, 0.9226647314090442]], [[0.7551484317488599, 0.8484153308573631], [0.7962079715427153, 0.8112868153908568], [0.7716913824750394, 0.6919078092773674], [0.7351770346465978, 0.6770554069722294], [0.6674064004310187, 0.7126763583712399], [0.6497462825613068, 0.7542346789173351], [0.7092029258536026, 0.8432703968019183], [0.7551484317488599, 0.8484153308573631]], [[0.8996952395388631, 0.8970326952400252], [0.8888710283282851, 0.9315108199671709], [0.9232236430596997, 1.0], [1.0, 1.0], [1.0, 0.8543064251337743], [0.8996952395388631, 0.8970326952400252]], [[0.22923147262180866, 0.856050599535783], [0.180119112683584, 0.7238600357677236], [0.09350590879701809, 0.716098494442338], [0.09538238421833437, 0.8601791343075224], [0.22923147262180866, 0.856050599535783]], [[0.6674064004310187, 0.7126763583712399], [0.5645661995465214, 0.6266202517455921], [0.5116287840371967, 0.7262985515337854], [0.5814975136113691, 0.7866301764869948], [0.6497462825613068, 0.7542346789173351], [0.6674064004310187, 0.7126763583712399]], [[0.22923147262180866, 0.856050599535783], [0.09538238421833437, 0.8601791343075224], [0.06547932140118774, 0.8929508510878428], [0.14175605689352533, 1.0], [0.17938028613592577, 1.0], [0.22923147262180866, 0.856050599535783]], [[0.10693271229777918, 0.4411925270273991], [0.03690306796464825, 0.32410393571869145], [0.0, 0.3173167473636119], [0.0, 0.4750694118792824], [0.10693271229777918, 0.4411925270273991]], [[0.8888710283282851, 0.9315108199671709], [0.7622830344072859, 0.9226647314090442], [0.7457774232302694, 1.0], [0.9232236430596997, 1.0], [0.8888710283282851, 0.9315108199671709]], [[0.5204458372927893, 0.3891790302185355], [0.4441166441878221, 0.3105874259219291], [0.3537602454680855, 0.333938023716593], [0.4240552422618216, 0.483872172450601], [0.5204458372927893, 0.3891790302185355]], [[0.32851498967179615, 0.6761902913899492], [0.3254682761762643, 0.7954785842645916], [0.4353650022192679, 0.829074150197124], [0.46532545533787595, 0.733718741024623], [0.3882893914503447, 0.6638790627978747], [0.32851498967179615, 0.6761902913899492]], [[0.09350590879701809, 0.716098494442338], [0.180119112683584, 0.7238600357677236], [0.24388202708478962, 0.6738381122876659], [0.19240335688786142, 0.5744543468004812], [0.14282316741592668, 0.551663174709632], [0.10851880979265245, 0.5841686042568631], [0.09350590879701809, 0.716098494442338]], [[0.06547932140118774, 0.8929508510878428], [0.09538238421833437, 0.8601791343075224], [0.09350590879701809, 0.716098494442338], [0.0, 0.7146135721020539], [0.0, 0.8993624900411141], [0.06547932140118774, 0.8929508510878428]], [[0.29992570383046435, 0.5106546411882987], [0.26684499083482294, 0.4952101164710062], [0.19240335688786142, 0.5744543468004812], [0.24388202708478962, 0.6738381122876659], [0.32851498967179615, 0.6761902913899492], [0.29992570383046435, 0.5106546411882987]], [[0.4353650022192679, 0.829074150197124], [0.3254682761762643, 0.7954785842645916], [0.27298268362116184, 0.8585071855293374], [0.3610554821287574, 0.9648793469876519], [0.4642558752553965, 0.8903926466797591], [0.4353650022192679, 0.829074150197124]], [[0.24388202708478962, 0.6738381122876659], [0.180119112683584, 0.7238600357677236], [0.22923147262180866, 0.856050599535783], [0.27298268362116184, 0.8585071855293374], [0.3254682761762643, 0.7954785842645916], [0.32851498967179615, 0.6761902913899492], [0.24388202708478962, 0.6738381122876659]], [[0.3610554821287574, 0.9648793469876519], [0.27298268362116184, 0.8585071855293374], [0.22923147262180866, 0.856050599535783], [0.17938028613592577, 1.0], [0.355021880888968, 1.0], [0.3610554821287574, 0.9648793469876519]], [[0.06547932140118774, 0.8929508510878428], [0.0, 0.8993624900411141], [0.0, 1.0], [0.14175605689352533, 1.0], [0.06547932140118774, 0.8929508510878428]], [[0.043778088062150305, 0.17368727054661914], [0.06906999197978334, 0.0821427000720589], [0.0, 0.011359147689904807], [0.0, 0.18779428799228035], [0.043778088062150305, 0.17368727054661914]]]

let native_polygons = [...polygons]
var randomnumber = Math.floor(Math.random() * (9));

export const voronoiConfig = {sibling_ordered:sibling_ordered, sibling:sibling}

export function getWordScreenshot(props) {

}

//export default function Voronoi(props) {
let Voronoi = React.forwardRef((props, reff) => {

    const [draw_object, setDrawObject] = useState(null)
    const [level, SetLevel] = useState()
    //let lens = Object.keys(sibling).length;
    //console.log(sibling)
    //console.log(sibling.length)
    const voronoiSVG = useRef();

    const gamedata = useRef(props.gamedata)
    const Vl = useRef(props.Vl)
    const letterVl = useRef(props.letterVl)
    const items = useRef(props.items)
    const is_first_init = useRef(props.init)
    const color = useRef(props.color)

    const globTheme = useTheme();
    let words_string;
   
    useEffect(() => {
        gamedata.current = props.gamedata
    }, [props.gamedata]);

    useLayoutEffect(() => {

        SetLevel(props.level)

        let data = gamedata.current;
        words_string = data.level_longstring;
        
        let mv_selected_list;
        items.current = props.items;

         if (is_first_init.current) {
            mv_selected_list = [...sibling_ordered]
         } else {
            mv_selected_list = items.current
         }
         setDrawObject(show_data_voronoi(Vl, letterVl, props.SelectionRef, words_string, mv_selected_list, is_first_init.current, props.id_object, props.color, 'hilite-mark2', {}, ''))
    }, [gamedata,props.palettemode, props.level, props.items, is_first_init, props.color, Vl, props.SelectionRef])

   return draw_object;

   function get_polygon_centroid(pts) {
        //var first = pts[0], last = pts[pts.length-1];
        //if (first[0] != last[0] || first[1] != last[1]) pts.push(first);
        var twicearea=0,
        x=0, y=0,
        nPts = pts.length,
        p1, p2, f;
        for ( var i=0, j=nPts-1 ; i<nPts ; j=i++ ) {
        p1 = pts[i]; p2 = pts[j];
        f = p1[0]*p2[1] - p2[0]*p1[1];
        twicearea += f;          
        x += ( p1[0] + p2[0] ) * f;
        y += ( p1[1] + p2[1] ) * f;
        }
        f = twicearea * 3;
        return { x:x/f, y:y/f };
    }

    function change_polygons() {

        let only_points = {}
        let polygons_centroid = []

        let polygons = [...native_polygons]
        for (let j = 0; j < polygons.length; j++) {
            
            let poligon = polygons[j]
            for (let i = 0; i < poligon.length-1; i++) {

              let a = poligon[i][0]
              let b = poligon[i][1]

              key = a.toString() + "," + b.toString(); 
              if (key in only_points)
                only_points[key].polys.push(j)
              else
                only_points[key] = {polys:[j], old_point:poligon[i], new_point:[]}
            }

            polygons_centroid[j] = get_polygon_centroid(poligon)
        }
        
        for (var key in only_points) {

            if (0 == only_points[key].old_point[0] || 0 == only_points[key].old_point[1] || 1 == only_points[key].old_point[0] || 1 == only_points[key].old_point[1] )
                continue

            if (only_points[key].polys.length > 2 ) {
                //console.log(key, only_points[key].polys)
                var x_arr = []
                var y_arr = []

                let new_obj = []

                for (let ii in only_points[key].polys) {
                    let a = polygons_centroid[only_points[key].polys[ii]].x
                    let b = polygons_centroid[only_points[key].polys[ii]].y

                    new_obj.push([a,b])
                    x_arr.push(a)
                    y_arr.push(b)
                }

                //new_center = get_polygon_centroid(new_obj)
                //x_center = new_center.x
                //y_center = new_center.y

                let x_center = x_arr.reduce((a, b) => a + b, 0) / x_arr.length ;
                let y_center = y_arr.reduce((a, b) => a + b, 0) / y_arr.length ;

                
                let parts = 40
                if (x_center<0.2 || x_center>0.8 || y_center<0.2 || y_center >0.8)
                     parts = 60

                if ( x_center > 0.5) 
                    x_center = x_center - Math.random()/parts
                else
                    x_center = x_center + Math.random()/parts

                if ( y_center > 0.5) 
                    y_center = y_center - Math.random()/parts
                else
                    y_center = y_center + Math.random()/parts
                
                //x_center = x_center + 0.005
                //y_center = y_center - 0.005
                only_points[key].new_point = [x_center, y_center]
                //console.log([x_center, y_center])

                for (let ii in only_points[key].polys) {
                    let i_pol = only_points[key].polys[ii]
                    let poligon = polygons[i_pol]

                    for (let i2 = 0; i2 < poligon.length-1; i2++) {
                        if (poligon[i2][0] == only_points[key].old_point[0] && poligon[i2][1] == only_points[key].old_point[1]) {
                            polygons[i_pol][i2] = only_points[key].new_point
                        }
                    }
                }
            }
        }
    }

    function show_data_voronoi(Jl, letterVl, SelectionRef, words_string,  show_list, is_first_init, id_object, color, n, o, r) {

        let letters = []
        //console.log(show_list)
        if (is_first_init)
            letters = words_string
            
        
        //f = $('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368 368" style="width:368px; height:368px" transform="translate(2,10)scale(1)" style="position:absolute;opacity:.6;"></svg>')

        /*
        // #876fc1
        if (n) 
            f.addClass(n)
        

        if (o)
            for (var v in o) f.attr(v, o[v]);
        
        //if (r)
        //      f.css("background-color", color)
        f.css("position", 'absolute')
        
        f.css("top", '0px')
        f.css("left", '0px')*/
        
        //if (is_first_init)
        //    f.css("opacity", '.6')


        /*if (!is_first_init)
            f.css("z-index", '0')*/

        //$(".crossword", Jl).prepend(f) 

        let scale = '1'
        
        let c_number = '#876fc1'
        let c_number_w = 0
        let c_size = 15

        let stroke_width = 1
        let stroke_color = 'black'
        let angle = "-45"
        let ppart = ""
        if (color && color.substring(0,5) == 'url(#' && n) {
            
            //stroke_width = 4
            //color = 'white'
            c_number_w = n.substring(n.length - 2)
            if ("-" == c_number_w.substring(0,1) )
                c_number_w = n.substring(n.length - 1)
            
            let color_list = ["red", "green", "grey", "blue", 'orange']

            c_number_w = parseInt(c_number_w)
            c_number = color_list[c_number_w % color_list.length]

            if (c_number_w >= color_list.length)
                //angle = "90"
                ppart = "2"

            if (c_number_w >= 2*color_list.length)
                angle = "90"

            if (c_number_w >= 3*color_list.length)
                angle = "45"
    
        }

        if (undefined == c_number) 
            c_number = 'grey'

        if (c_number && color == 'url(#secondPattern)')
            color = 'url(#secondPattern'+ ppart + c_number + '_' + c_size + '_' + angle + ')'

        let html = '<defs><pattern id="secondPattern'+ c_number + '_' + c_size + '_' + angle +'" patternUnits="userSpaceOnUse" width="5" height="2.5" opacity="0.2" patternTransform="rotate('+ angle +')"><line x1="0" y="0" x2="0" y2="5.5" stroke="'+ c_number + '" stroke-width="2" /></pattern><pattern id="secondPattern2'+ c_number + '_' + c_size + '_' + angle +'" opacity="0.2" x="2" y="2" width="40" height="20" patternUnits="userSpaceOnUse"><rect x="' + c_size + '" y="' + c_size + '" width="5" height="5" fill= "'+ c_number + '" /></pattern></defs>';
        let htmls = [];

        let gradient = <></>
        if (!is_first_init && props.is_show_last)
            gradient = <><pattern id="grad2" width="30" height="10" 
            patternTransform="rotate(130)" patternUnits="userSpaceOnUse">
                <rect width="100%" height="100%" fill={color}></rect>
                <line x1="5" x2="5" y2="10" style={{stroke:"grey", strokeWidth:3}} />
                
           </pattern>
           </>
        
        if (is_first_init) {

            change_polygons()
        };

        let centroid = {};
        var i = 0;
        //console.log(show_list)
        for (var index in show_list) {
            
            let item;
            //console.log(index)
            if (-1 != Object.keys(show_list[index]).indexOf('z'))
                item = show_list[index].z.toString();
            else
                item = show_list[index].toString()

            //num = parseInt(path[item]);
            let num = parseInt(item);
            //if (num !=0) continue
            let poligon = polygons[num]
            let points = ''
            let x = []
            let y = []
                       
            for (let i = 0; i < poligon.length-1; i++) {

              let a = poligon[i][0]
              let b = poligon[i][1]

              if (1 == randomnumber % 4)
                b = 1 - b

              if (2 == randomnumber % 4)
                a = 1 - a

               if (3 == randomnumber % 4 ) {
                b = 1 - b
                a = 1 - a
               }

               if (4 < randomnumber) {
                [a, b] = [b, a]
               }

              //a = 1 - a

              points += " " + 350*a + "," + 350*b; 
              x.push(a)
              y.push(b)
            }

            //x_center = 350* x.reduce((a, b) => a + b, 0) / x.length;
            //y_center = 350* y.reduce((a, b) => a + b, 0) / y.length;
           

            //x_center=350*(Math.max.apply(null, x) + Math.min.apply(null, x))/2.
            //y_center = 350*(Math.max.apply(null, y)+Math.min.apply(null, y))/2.
            let xx = get_polygon_centroid(poligon)
            let x_center = 350*xx.x
            let y_center = 350*(xx.y)

            if (1 == randomnumber % 4)
                //b = 1 - b
                y_center = 350*(1 - xx.y)

            if (2 == randomnumber % 4)
                x_center = 350*(1 - xx.x)

            if (3 == randomnumber % 4) {
                y_center = 350*(1 - xx.y)
                x_center = 350*(1 - xx.x)
            }

            if (4 < randomnumber) {
                [y_center, x_center] = [x_center, y_center]
            }

            centroid[item]= [x_center,y_center]
           /*
            if (1 == Math.max.apply(null, y))
                y_center = y_center + 3

            if (0 == Math.min.apply(null, y))
                y_center = y_center - 2

            if (0 == Math.min.apply(null, x))
                x_center = x_center - 5

            if (1 == Math.max.apply(null, x))
                x_center = x_center + 3
*/
            let letter_shift = {x: x_center, y: y_center}
            
            /*
            col = parseInt(item[0]);
            row = parseInt(item[1]);
            frm = parseInt(item[2]);*/

            let frm = 1
            let path_style = 'style=""';
            //if (1 == frm)  {transform = 'rotate(90)';  letter_shift = 'x="140" y="210"'}
            //if (2 == frm) {transform = 'rotate(180)'; letter_shift = 'x="100" y="140"'}
            //if (3 == frm) {transform = 'rotate(-90)'; letter_shift = 'x="170" y="110"';path_style = 'style="width:36px; height:45px"';}
            /*if (4 == frm)*/
            let transform = ''; 
            
            let hh = 37.45
            
            let  shift_x_delta = 0; 
            let  shift_y_delta = 0;

            /* 
            if (1 == col || 7 == col) {
                shift_y_delta = hh;
            }


            if (0 == col % 2) {
                shift_y_delta = hh / 2;
            }

            if (0 == col || 8 == col) {
                shift_y_delta = 1.5*hh;
            }*/
            /*
            if (0 == col % 2) {
                //shift_x_delta = 37.8; shift_y_delta = 0;
            }

            if (1 == col % 2) {
                shift_x_delta = 0; shift_y_delta = 0;
            }
            */
            
            /*
            shift_x = 0 + (hh  - 5.)* (col -1);
            shift_y = 0  + (hh - 0) * (row -1);
            */
            let shift_x = 0
            let shift_y = 0

            shift_x = shift_x + shift_x_delta
            shift_y = shift_y + shift_y_delta 

            // style="align: middle;font:22px short_filmsmedium;"
            let text_style={fill: globTheme.palette.board.text, align: "middle",fontSize:"22px", fontFamily:"short_filmsmedium",  textTransform:"uppercase"}

            let letter_box = '';
            /*if ( letters.length > 0 && id_object) {
                var l_count = sibling_ordered.indexOf(item);
                letter_box = <text x="155" y="160"  dominantBaseline={"middle"}  textAnchor={"middle"} style={text_style} className={"letter-in-box"} transform-origin={"center"}>{letters[l_count]}</text>;
            
            } else */
            if ( letters.length > 0 ) {
                
                letter_box = <text ref={(el) => {letterVl.current['z'+ item] = el;}} {...letter_shift}  dominantBaseline={"middle"}  textAnchor={"middle"} style={text_style} className={"letter-in-box"} transform-origin="center">{letters[i]}</text>;
            }
            let z_factor = ""

            var opts1 = {};
            if (is_first_init) {
                //z_factor = 'data-z="' + item + '"'
                opts1['data-z'] = item;
                //opts1['backgroundColor'] = "white";
                opts1['ref'] = (el) => {Vl.current[item] = el;};
                opts1['onMouseDown'] = (e) => SelectionRef.current.mv_beginSelectingWord(e, props.largeBoard, globTheme.palette.board.selection);
                opts1['onTouchStart'] = (e) => SelectionRef.current.mv_beginSelectingWord(e, props.largeBoard, globTheme.palette.board.selection);
                opts1['onMouseUp'] = (e) => SelectionRef.current.mv_endSelectingWord(e, globTheme.palette.board.selection);
                opts1['onTouchEnd'] = (e) => SelectionRef.current.mv_endSelectingWord(e, globTheme.palette.board.selection);
                opts1['onMouseMove'] = (e) => SelectionRef.current.mv_hiliteSelection(e, props.largeBoard, globTheme.palette.board.selection);
                opts1['onTouchMove'] = (e) => SelectionRef.current.mv_hiliteSelection(e, props.largeBoard, globTheme.palette.board.selection);
                
            }

            /*if (is_first_init)
                z_factor = 'data-z="' + item + '"'*/

            var opts2 = {};
            //let str_fill = 'fill="' + color + '"'
            opts2['fill'] = color;
            opts2['stroke'] = globTheme.palette.board.stroke;
            //"#bdbdbd"; //let stroke_color = '#FFF';
                
                
            if (!is_first_init && props.is_show_last) {
                //opts2['fill'] = 'yellow';
                opts2['fill'] = "url(#grad2)";
            }   
            //str_fill = ''

            let str_fill_opacity = ''
            if (is_first_init)
                //str_fill_opacity = 'filfl-opacity="0.2"'
                opts2['fillOpacity'] = .1
            else
                //str_fill_opacity = 'fill-opacity="0.8"'
                opts2['fillOpacity'] = .8
    
            /*
            let str_fill = 'fill="' + color + '"'
            //str_fill = ''

            let str_fill_opacity = ''
            if (is_first_init)
                str_fill_opacity = 'fill-opacity="0.2"'
            else
                str_fill_opacity = 'fill-opacity="0.8"'

            //str_fill = ''
            // fill="url(#secondPattern)"*/


            let newItem = <g className="box"  key={index} {...opts1}  transform={'translate('+ shift_x +','+ shift_y + ')scale('+scale+')'}>
                <polygon {...opts2}  strokeWidth={stroke_width} points={points}  transform={transform} transform-origin={"center"}/>
                {letter_box}
                </g>;

            
            //html = html + newItem;
            htmls.push(newItem);
            i = i + 1
        }

        
        /*
        if (is_first_init && 0)
        for (var i in centroid) {

          let points = ''
          let a = centroid[i][0]
          let b = centroid[i][1]

          //points += " " + a + "," + b; 

          let s_index = i.toString()
          if (s_index == '0') s_index = '00'
          
          let ss = sibling[s_index]
            
          //console.log('Loop:', i, s_index, ss) 
          
          for (let j = 0; j < ss.length; j++) {
             let s_index2 = ss[j]
              //s_index2 = ss[j].toString()
              //if (s_index2 == '0') s_index2 = '00'  
              //console.log()  
              //console.log(s_index2, centroid[s_index2])
              
              let a1 = centroid[s_index2][0]
              let b1 = centroid[s_index2][1]

              points += " " + a + "," + b;
              points += " " + a1 + "," + b1; 
          }
          points += " " + a + "," + b; 

            let str_fill = 'fill="none"'
            let style="fill:none;stroke:black;stroke-width:3"
            let stroke_color = 'red'
            let newItem = <g className="box"  z_factor  transform="translate('+ shift_x +','+ shift_y + ')scale('+scale+')">
                <polyline path_style  str_fill str_fill_opacity  strokeWidth='+ stroke_width + ' stroke="'+ stroke_color + '" points="' + points + '"  transform="' + transform + '" transform-origin="center"/>
                </g>;
            //if ('2' == s_index)
                html = html + newItem;

            //if ('2' == s_index)
            //    break;
        }*/
        
        //f.html(html);
        //$(".crossword", Jl).prepend(f)
        //$("#main_svg").append($circle);

        let style1 = {width: "100%"}
        style1.position="absolute";
        style1.left="0px";
        style1.top="0px";
        
        if (!is_first_init) {
            style1.zIndex = -1;
            //style1.top = 0;
            
        }else {
            //style1.zIndex = -1000;
        };

        let str_scale = "translate(0,0)scale(0.87)";
        let str_to = "0,0"
        let begin="indefinite"

        let f = <svg  {...id_object} xmlns="http://www.w3.org/2000/svg" className={n} viewBox="0 0 305 305" style={style1} >
              <defs>{gradient}</defs>
            <g ref={voronoiSVG}  transform={str_scale}>
                {htmls}
            </g>
            </svg>
        //console.log(f)
        return f
    }
})

export default Voronoi;